import { Separator } from "design-system/atoms/Separator"
import { SidebarTrigger } from "design-system/organisms/Sidebar"
import { Breadcrumbs } from "../Breadcrumbs"

export function SiteHeader() {
  return (
    <header className="rounded-t-lg flex h-14 shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear bg-background/40 backdrop-blur-xl sticky top-0 z-50">
      <div className="flex w-full items-center px-4 gap-2 shrink-0">
        <SidebarTrigger className="shrink-0" />
        <Separator
          orientation="vertical"
          className="mx-1 my-auto data-[orientation=vertical]:h-6"
        />
        <Breadcrumbs />
      </div>
    </header>
  )
}
